import { RSAA } from "redux-api-middleware";

import * as types from "./auth.constants";
import {
  API_MODULES as modules,
  API_METHODS as methods,
} from "../../api.constants";

import { JwtService } from "../../../services/Jwt.service";

// see the counterpart AngularJS implementation in Auth.doGetAccessToken
export const getAccessToken = () => {
  let headers;

  // Send the old authorization in order to restore context of
  // the original and impersonated user on BE. We use a different header
  // from Authorization because the token could be already
  // expired (we only need it to restore the context, not for validation,
  // which is performed by the refresh token)
  const tokenValue = JwtService.getTokenValue();
  if (JwtService.isImpersonatedToken() && tokenValue) {
    headers = {
      "X-Expired-Authorization": tokenValue,
    };
  }

  return {
    [RSAA]: {
      endpoint: "authenticate?",
      method: methods.GET,
      module: modules.GATEWAY,
      credentials: "include" as const,
      headers,
      options: {
        mode: "cors" as const,
      },
      noAuthHeader: true,
      types: [
        types.GET_ACCESS_TOKEN,
        types.GET_ACCESS_TOKEN_SUCCESS,
        types.GET_ACCESS_TOKEN_FAILURE,
      ] as [string, string, string],
    },
  };
};

export const setAccessToken = (payload: unknown) => ({
  type: types.SET_ACCESS_TOKEN,
  token: payload,
});

export const saveRefreshTokenPromise = (promise: unknown) => ({
  type: types.SAVE_REFRESH_TOKEN_PROMISE,
  promise,
});

export const clearRefreshTokenPromise = () => ({
  type: types.CLEAR_REFRESH_TOKEN_PROMISE,
});
